// extracted by mini-css-extract-plugin
module.exports = {"change-container":"ApprovePaymentModalFooter_change-container__3XZO_","change":"ApprovePaymentModalFooter_change__1Z_Ok","change-ltr":"ApprovePaymentModalFooter_change-ltr__B6RBA"};